<template>
  <el-dialog
    :title="this.$t('prescriptionList.title.details')"
    :visible.sync="dialogVisible"
    width="1200px"
    @close="closeDialog"
  >
    <el-tabs class="batchTabs" type="border-card" v-model="tabActive">
      <el-tab-pane
        v-if="tabActive == 'productNameJoining'"
        :label="$t('prescriptionList.title.productName')"
        name="productNameJoining"
      >
        <product-name ref="productName" :formulaNo="this.formulaNo" />
      </el-tab-pane>
      <el-tab-pane
        v-else-if="tabActive == 'productNameSpec'"
        :label="$t('prescriptionList.title.materialDesc')"
        name="productNameSpec"
      >
        <product-name-spec ref="productNameSpec" :formulaId="this.formulaId" />
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
</template>
<script>
  // import API from '@/api/productCenter/prescriptionData';
  import ProductName from './components/productNameQuery'; //销售商品明细
  import ProductNameSpec from './components/productNameSpecQuery'; //配料描述明细
  export default {
    name: 'prescriptionDataDetailQuery',
    components: {
      ProductName,
      ProductNameSpec,
    },
    data() {
      return {
        rowItem: {},
        tabActive: '',
        dialogVisible: false,
        formulaId: null,
        formulaNo: null,
        componentsList: [
          { componentKey: 'productName', dataKey: 'pdProductList' },
          { componentKey: 'productNameSpec', dataKey: 'sysFormulaDetails' },
        ],
      };
    },
    methods: {
      openDialog(rowItem) {
        this.tabActive = rowItem.column.property;
        this.dialogVisible = true;
        this.formulaId = rowItem.row.id;
        this.formulaNo = rowItem.row.formulaNo;
        if (rowItem.column.property == 'productNameJoining') {
          this.$nextTick(() => {
            this.$refs.productName.resetBtnClick();
          });
        } else if (rowItem.column.property == 'productNameSpec') {
          this.$nextTick(() => {
            this.$refs.productNameSpec.resetBtnClick();
          });
        }
      },
      closeDialog() {
        // 弹窗关闭
        this.dialogVisible = false;
        //this.$emit('updateTableData', this.exportDetail());
      },

      exportDetail() {
        this.componentsList.map((item) => {
          let detailItem = this.rowItem[item.dataKey];
          if (detailItem && detailItem.length > 0) {
            detailItem.map((it) => {
              it.serializationJsonData = JSON.stringify(it.serializationJsonData);
            });
          } else {
            detailItem = null;
          }
        });
        return this.rowItem;
      },
    },
  };
</script>
